/*
 * Relo-Poland Premium — the small amount of behaviour the Payload site had as
 * React state, rewritten as progressive enhancement. Everything here degrades
 * to a working page with JS off: the locale switcher is a real <form>, the
 * gallery thumbs are real links to ?variant=, quantity inputs submit normally.
 */
(function () {
  'use strict';

  /* Header goes translucent once you leave the top of the page. */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('site-header--scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Locale menu: click-outside and Escape close it, same as the React version. */
  document.querySelectorAll('[data-disclosure]').forEach(function (root) {
    var button = root.querySelector('[data-disclosure-button]');
    var menu = root.querySelector('[data-disclosure-menu]');
    if (!button || !menu) return;

    var close = function () {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    };

    button.addEventListener('click', function () {
      var open = menu.hidden;
      menu.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('mousedown', function (event) {
      if (!root.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  });

  /* Product gallery: swap the main image without a page load. */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.fullSrcset || '';
        main.alt = thumb.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
          other.setAttribute('aria-current', String(other === thumb));
        });
      });
    });
  }

  /* Variant picker. Shopify needs the variant id in a hidden input; the selects
     carry option values, so map the chosen combination back to a variant. */
  var variantForm = document.querySelector('[data-variant-form]');
  if (variantForm) {
    var variants = JSON.parse(variantForm.dataset.variants || '[]');
    var idInput = variantForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = variantForm.querySelector('[data-add-to-cart]');
    var selects = Array.prototype.slice.call(
      variantForm.querySelectorAll('[data-option-index]')
    );

    var sync = function () {
      var chosen = selects.map(function (select) {
        return select.value;
      });
      var match = variants.filter(function (variant) {
        return chosen.every(function (value, index) {
          return variant.options[index] === value;
        });
      })[0];

      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.dataset.labelAvailable
          : submit.dataset.labelSoldOut;
      }
    };

    selects.forEach(function (select) {
      select.addEventListener('change', sync);
    });
    sync();
  }

  /* Cart quantity inputs submit the cart form on change, so there is no separate
     "update" button to forget to press. */
  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
